import { FIELDS_OF_LAW_ENDPOINT } from 'common/constants'
import { request } from 'common/utils'

import query from '../graphql/deleteFieldOfLaw.graphql'
import { DeleteFieldOfLawMutation } from '../interfaces/schemaDefinition'

export const deleteFieldOfLaw = (id: string): Promise<DeleteFieldOfLawMutation | undefined> =>
  request<DeleteFieldOfLawMutation>(FIELDS_OF_LAW_ENDPOINT, query, { id }).catch(() => undefined)
